import { Outlet } from 'react-router';

const Diagnose = () => {
  return <Outlet />;
};

export default Diagnose;
